import React from 'react';

const MenuCategory = ({ title, titleColor = 'text-neon-pink', children }) => {
  return (
    <div>
      <h3 className={`text-3xl font-bold ${titleColor} mb-8 text-center`} style={{ fontFamily: "'Playfair Display', serif" }}>
        {title}
      </h3>
      {children}
    </div>
  );
};

export default MenuCategory;
